<template>
    <v-container>
        <v-toolbar flat>
            <v-card-actions>
                <v-icon @click="backToQuestions" color="secondary"  style="margin-right: 10px">
                    mdi-arrow-left-thick
                </v-icon>
            </v-card-actions>
            <v-toolbar-title style=""><b>Edit Question {{question.questionId}}</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar> 

        <v-form ref="form" @submit.prevent="saveQuestion" class="custom_form">
            <v-card>
                <v-row no-gutters>
                    <v-col cols="3">
                        <v-switch
                            v-model="question.questionStatus"
                            inset
                            dense
                            class="mt-2 ml-6" 
                            color="blue"
                            @change="putQuestionStatus()"
                            :label="question.questionStatus ? 'Active' : 'Inactive'"
                        >
    
                        </v-switch>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                        <v-card-actions style="justify-content:center;">
                            <v-btn
                                class="mx-5"
                                :disabled="disabled"
                                type="submit"
                                color="secondary"
                                width="200"
                                @click="saveQuestion"
                            >Save Changes</v-btn
                            >
                        </v-card-actions>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-container>
                    <v-dialog persistent v-model="editTextDialog" width="900" height="800">
                        <EditText :editedText="toBeEditedText" @changeEditedText="changeEditedText($event)"/>
                    </v-dialog> 

                       <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5"> Question Type </v-card-text>
                    </v-col>
                    <v-col cols="1">
                         <v-text-field
                            outlined
                            dense 
                            value="1"
                            disabled
                        ></v-text-field>
                        <!-- @click="editTextStatement($event)"
                            :rules="questionStatementRules"
                            :success="questionStatementSuccess" -->
                    </v-col>
                </v-row>
                
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5"> Statement </v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="question.questionStatement"
                            outlined
                            dense 
                            clearable
                            @click="editTextStatement($event)"
                            :rules="questionStatementRules"
                            :success="questionStatementSuccess"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-1">
                        <v-card-text class="pr-5">
                            Key Sequence
                        </v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div style="width:500">
                            <template  v-for="(itm, indx) in question.questionKeySequence">
                                <v-chip :key="indx" close @click:close="deleteKey(indx)">
                                    {{itm}}  
                                </v-chip>
                            </template>
                        </div>
                    </v-col> 
                </v-row>

                <v-row>    
                    <v-card style="width:150px" class="ml-15 mt-4">
                        <ul style="text-decoration:none" v-for="(key, i) in keySequenceMaster4" :key="i">
                            <v-row>
                                <v-col cols="5" style="font-size:15px" no-gutters class="ma-0 pa-0">
                                    {{key}}
                                </v-col>
                                <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"><v-icon style="font-size:15px" no-gutters @click="addKey4(i)">mdi-plus</v-icon>
                                </v-col>
                            </v-row>
                        </ul>
                    </v-card>

                    <v-card style="width:150px" class="ml-5 mt-4">
                        <ul style="text-decoration:none" v-for="(key, i) in keySequenceMaster5" :key="i">
                            <v-row>
                                <v-col cols="5" style="font-size:15px" class="ma-0 pa-0">
                                    {{key}}
                                </v-col>
                            <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"><v-icon style="font-size:15px" @click="addKey5(i)">mdi-plus</v-icon>
                            </v-col>
                        </v-row>
                        </ul>
                    </v-card>

                    <v-card style="width:150px" class="ml-5 mt-4">
                        <ul style="text-decoration:none" v-for="(key, i) in keySequenceMaster6" :key="i">
                            <v-row>
                                <v-col cols="5" style="font-size:15px" class="ma-0 pa-0">
                                    {{key}}
                                </v-col>
                                <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"><v-icon  style="font-size:15px" @click="addKey6(i)">mdi-plus</v-icon>
                                </v-col>
                            </v-row>
                        </ul>
                    </v-card>  
                </v-row>

                <v-row no-gutters  class="my-4">
                    <v-col cols="2" align="right" class="mr-3 mt-4">
                        <v-card-text class="pr-5"> Audio </v-card-text>
                    </v-col>
                    <v-col cols="6" class="mt-4">
                        <v-badge
                            right
                            top
                            avatar 
                            overlap
                            color="blue" 
                            class="for_custom-badge"
                        >
                            <template v-slot:badge>
                                <v-avatar size="36" align="left">
                                    <v-file-input
                                        accept="audio/*"
                                        prepend-icon="mdi-pencil-outline"
                                        label="questionAudio"
                                        ref="fileAudio"
                                        hide-input
                                        dense
                                        :rules="questionAudioRules"
                                        :success="questionAudioSuccess"
                                        @change="onAudioFileSelected"                              
                                    >
                                    </v-file-input> 
                                </v-avatar>
                            </template>
                            <audio 
                                ref="audioElm" 
                                :src='questionAud' 
                                controls
                                max-height="50"
                                min-height="50"
                                max-width="150"
                                min-width="150"
                                contain
                                elevation
                            >
                             </audio>
                        </v-badge>
                    </v-col>
                </v-row>
        
                <v-row v-if="errorMessage || successMessage">
                    <v-col cols="6" offset-md="2">
                        <v-alert v-if="errorMessage" type="error">
                            {{errorMessage}}
                        </v-alert>
                        <v-alert v-if="successMessage" type="success">
                            {{successMessage}}
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-form>
  </v-container>
</template>

<script>
import TypeOneQuestion from "../../models/TypeOneQuestion";
import LessonQuestionMapping from "../../models/LessonQuestionMapping";
import {mapMutations } from "vuex";
import url1 from '../../../config.js';
import EditText from "../../components/admin/EditText";
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                   {
                       vm.$router.push("/");
                   }
            }, 0);
        });
    },
    name: "TypeOneQuestionInfoEdit",
    components:{
        EditText
    },
    data() {
        return {
                items:[],
                url:url1.url,
                //question_id_temp:'',
                question_id:'',
                successMessage:'',
                search:'',
                errorMessage:'',
                disabled:false,
                question:new TypeOneQuestion(), 
                questionAud:'',
                questionKeySequence:'',
                questionType:'',
                file:'', 
                toBeEditedText:'',
                inputType: '',
                textField:null,
                editTextDialog:false,
                keySequenceMaster4:[
                 "4C", "4C#", "4D", "4D#", "4E", "4F", "4F#", "4G", "4G#", "4A","4A#", "4B"
                 ], 

                keySequenceMaster5:[
                 "5C", "5C#", "5D", "5D#", "5E", "5F", "5F#", "5G", "5G#", "5A","5A#", "5B"
                 ], 

                keySequenceMaster6:[
                 "6C", "6C#", "6D", "6D#", "6E", "6F", "6F#", "6G", "6G#", "6A","6A#", "6B"
                 ], 
            /*    
                  questionTitleSuccess: false,
                  questionTitleRules: [
                v => {
                    if (v)
                    {
                        this.questionTitleSuccess = true;
                        return true;
                    } else {
                        this.questionTitleSuccess= false;
                        return "Title is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Title must be at least 2 characters long",
                v =>
                    (v || "").length <= 30 ||
                    "Title must be less than 30 characters"
            ],*/
/*
            questionDescriptionSuccess:false,
            questionDescriptionRules: [
                v => {
                    if (v) {
                        this.questionDescriptionSuccess = true;
                        return true;
                    } else {
                        return "Description is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Description be at least 2 characters long",
                v =>
                    (v || "").length <= 1000 ||
                    "Description must be less than 1000 characters"
            ],
            */
            questionStatementSuccess:false,
            questionStatementRules: [
                v => {
                    if (v) {
                        this.questionStatementSuccess = true;
                        return true;
                    } else {
                        this.questionStatementSuccess = false;
                        return "Statement is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Statement be at least 2 characters long",
                v =>
                    (v || "").length <= 255 ||
                    "Statement must be less than 255 characters"
            ],
            
            questionAudioSuccess: false,
            questionAudioRules: [        
                // v =>
                //     (!v || v.size<1000000) ||"Question audio size should be less than 1MB",
                ],

            //questionStatusSuccess: false,//to be changed
            // questionStatusRules: [
            //       v => 
            //         {
            //         if (v) {
            //             this.questionStatusSuccess = true;
            //             return true;
            //         } else {
            //             return "Question Status is required";
            //         }
            //     },
                // v =>
                //     (v || "").length == 10 ||
                //     "Phone must be 10 characters long"    
            // ],
            
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    methods:{
        ...mapMutations(["removeQuestion"]),
        
      /*  onImageFileSelected () {
            console.log('event', event);
            console.log('file beginning', event);//.target.files[0]);
            const file = event;//.target.files
            console.log('files', file);
            this.imageFileName = file.name
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
            this.imageUrl = fileReader.result
   })
    fileReader.readAsDataURL(file)
    this.question.questionImage = file;
        console.log('files image 1');
        if(event.target.files[0])
                {
                    console.log('files image 2');
                   // console.log('check target');
                    //const file= event.target.files[0];
                    //this.file=file;
                    this.file= event.target.files[0];
                   // this.adminUser.profilePicture=this.file;
                   // this.adminUser.profilePicture = event.target.files[0];
                    var reader = new FileReader();
                    var vm = this;

                   reader.onload = (e) => {
                   // vm.lesson.lessonAud = e.target.result;
                   vm.questionImg = e.target.result;
                   };
                   reader.readAsDataURL(this.file);
                   //this.image=this.file;
                   this.question.questionImage=this.file;
                    //this.lesson.lessonImage=event.target.result;//URL.createObjectURL(event.target.files[0]);
                    console.log('this.profilepicture', this.question.questionImage, 'event.targetfiles', event.target.files[0]);
                    //console.log('profile picture',this.file,this.adminUser.profilePicture);
                   // console.log('profile picture',this.adminUser.profilePicture);
                }
            },*/
            onAudioFileSelected(){
                if(event.target.files[0])
                    {
                        this.file= event.target.files[0];
                        var reader = new FileReader();
                        var vm = this;

                        reader.onload = (e) => {
                            vm.questionAud = e.target.result;
                        };
                        reader.readAsDataURL(this.file);
                        this.question.questionAudio=this.file;
                        //console.log('this.on audio file selected', this.question.questionAudio, 'event.tagetfiles', event.target.files[0]);
                    }
            },

        getQuestion() {
            TypeOneQuestion.getQuestionInfo(this.question_id, this.questionType, this.auth.token).then((res)=>{
            console.log('Get question Client res.data client type 1', res.data);
            this.question=res.data;
            this.question.questionType=1;
            //this.questionImg=`${this.url}/uploads/`+res.data[0].questionImage;
            this.questionAud=`${this.url}/uploads/`+res.data.questionAudio;
            console.log('Get questions.question', this.question);
            })
           // console.log('question image', this.questionImg);
        },
        saveQuestion() {
            this.disabled = true;

                //  if (this.question.questionTitle.length<2 ||this.question.questionTitle.length>30)
                //  {
                //     this.errorMessage = 'Title should be valid';
                //     setTimeout(() => (this.errorMessage = ""), 5000);
                //     this.disabled = false;
                //     return;
                //  }
                //  if (this.question.questionDescription.length<2 || this.question.questionDescription.length>1000)
                //  {
                //     this.errorMessage = 'Description should be valid';
                //     setTimeout(() => (this.errorMessage = ""), 5000);
                //     this.disabled = false;
                //     return;
                //  }

                // if (this.question.questionStatement&&(this.question.questionStatement.length<2 || this.question.questionStatement.length>1000))
            if (this.question.questionStatement.length<2 || this.question.questionStatement.length>255)
                {
                    this.errorMessage = 'Statement should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }

                // if (this.question.questionImage&&this.question.questionImage.size>1000000)
                // {
                //     this.errorMessage = 'Image should be valid';
                //     setTimeout(() => (this.errorMessage = ""), 5000);
                //     this.disabled = false;
                //     return;
                //  }

                /*if (this.question.questionAudio&&this.question.questionAudio.size>1000000)
                {
                    this.errorMessage = 'Audio should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }*/
            /*
            if (!this.question.questionAudio)
                {
                    this.errorMessage = 'Audio should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }
            */

            // if (this.question.questionKeySequence.length===0)
            //     {
            //         //console.log('question key seq inside ', this.question.questionKeySequence);
            //         this.errorMessage = 'Key sequence should be valid';
            //         setTimeout(() => (this.errorMessage = ""), 5000);
            //         this.disabled = false;
            //         return;
            //     }
            if(!this.question.questionStatus)
                {
                    this.question.questionStatus=false;
                }


            if (!(this.question.questionStatus===true) && !(this.question.questionStatus===false))
                {
                    //console.log('question status inside', this.question.questionStatus);
                    this.errorMessage = 'Status should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }

                // const formData=new FormData();
                const formData={
                    questionAudio:this.question.questionAudio,
                    questionStatement:this.question.questionStatement,
                    questionKeySequence:this.question.questionKeySequence,
                    questionStatus:this.question.questionStatus

                    }

                // this.questionKeySequence=JSON.stringify(this.question.questionKeySequence)
                //formData.append('questionTitle', this.question.questionTitle);
                // formData.append('questionDescription', this.question.questionDescription);
                // formData.append('questionImage', this.question.questionImage);
                // formData.append('questionAudio', this.question.questionAudio);
                // formData.append('questionStatement', this.question.questionStatement);
                // formData.append('questionKeySequence', this.questionKeySequence);
                // formData.append('questionStatus', this.question.questionStatus);//not required here
                // for(var pair of formData.entries()) {
                //     console.log('formData', pair[0]+ ', '+ pair[1]); 
                // }
                //console.log('update question question_id', this.question._id);
                TypeOneQuestion.putQuestion( this.question._id, formData, this.auth.token)//to continue from here
                    .then(res => {
                        this.disabled = false;
                        console.log('res', res);
                        this.successMessage = 'Question updated successfully';
                        setTimeout(() => (this.successMessage = ""), 5000);
                       // this.$refs.form.reset();
                    })
                    .catch(err => {
                        this.errorMessage = err.response.data;
                        console.log('error in put type 1', this.errorMessage);
                        setTimeout(() => (this.errorMessage = ""), 5000);
                        this.disabled = false;
                    });
        },
               
        putQuestionStatus()
            {
                LessonQuestionMapping.putQuestionStatusonMasterStatusChange(this.question._id, this.question.questionStatus, this.question.questionType, this.auth.token).then(res=>{
                    console.log('put status change question', res.data);
                }).catch(err=>{
                    console.log(err.response.data);
              });
            },

            backToQuestions(){
                this.removeQuestion();
                this.$router.replace('/admin/questions');
            },
        addKey4(index)
        {
            //console.log("edited item", this.question.questionKeySequence);
            this.question.questionKeySequence.push(this.keySequenceMaster4[index]);
            //console.log(this.question.questionKeySequence);
        },

        addKey5(index)
        {
            //console.log("edited item", this.question.questionKeySequence);
            this.question.questionKeySequence.push(this.keySequenceMaster5[index]);
            //console.log(this.question.questionKeySequence);
        },

        addKey6(index)
        {
            //console.log("edited item", this.question.lessonKeySequence);
            this.question.questionKeySequence.push(this.keySequenceMaster6[index]);
            //console.log(this.question.questionKeySequence);
        },

        deleteKey(index)
        {
            this.question.questionKeySequence.splice(index, 1);
        },

        clearForm(){
            this.$refs.form.resetValidation();
        },

        editTextStatement(e){
            this.textField=e.target;
            this.textField.blur();
            this.inputType="statement";
            this.toBeEditedText=this.question.questionStatement;
            this.editTextDialog=true;
        },

        changeEditedText(editedText) {
            if(editedText===null)
            {
                this.editTextDialog=false;
            }
            else
            {
                //console.log("Selected: "+ this.inputType );
                this.toBeEditedText=editedText;
                if(this.inputType == 'statement') 
                {
                    this.question.questionStatement = editedText;
                }
            }
            this.editTextDialog = false;
        }

    }, 
    mounted(){
        this.question_id=this.$store.state.question.question_id;
        this.questionType=this.$store.state.question.questionType;
        //this.question=this.$store.state.question;
        this.getQuestion(this.question_id);//to check earlier temp
        console.log('inside type one info edit', this.question);
        //this.questionAud=`${url1.url}/uploads/${this.question.questionAudio}`
    }
}
</script>

<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
.custom_form >>> .v-card__text {
    padding: 10px 16px;
}
.custom_form >>> .v-badge__badge.blue {
    height: 30px;
    min-width: 30px;
    border-radius: 50px;
}
.custom_form >>> .mdi-pencil-outline::before {
    font-size: 18px;
}
.custom_form >>> .v-input__append-outer,
.custom_form >>> .v-input__prepend-outer {
    margin-top: 9px;
}
</style>